<template>
  <VApp id="app">
    <AppNavDrawer v-if="isLoggedIn" />
    <AppToolbar />
    <VContent style="padding-bottom: 36px">
      <VContainer fluid pa-0>
        <Transition name="fade" mode="out-in">
          <router-view />
        </Transition>
      </VContainer>
    </VContent>
    <VFooter app fixed class="primary">
      <div style="color: white; padding-left: 16px">
        © {{ new Date().getFullYear() }} Algoritmik d.o.o
      </div>
    </VFooter>
    <VSnackbar
      v-model="snackBarState"
      :timeout="5000"
      :color="snackBarColor"
      :multi-line="true"
      :vertical="false"
    >
      {{ snackBarText }}
      <VBtn
        dark
        flat
        @click.native="
          $store.dispatch('setSnackBarStateAction', { snackBar: false, color: 'success', text: '' })
        "
      >
        Zapri
      </VBtn>
    </VSnackbar>
  </VApp>
</template>

<script>
/* eslint-disable */

import { mapActions, mapGetters } from 'vuex';
import Toolbar from './components/Toolbar';
import NavDrawer from './components/NavDrawer';
export default {
  name: 'App',
  components: {
    AppToolbar: Toolbar,
    AppNavDrawer: NavDrawer,
  },
  computed: {
    ...mapGetters(['snackBarColor', 'snackBarText', 'isLoggedIn', 'snackBar']),
    snackBarState: {
      set(value) {
        this.setSnackBarStateAction({ snackBar: value, color: 'success', text: '' });
      },
      get() {
        return this.snackBar;
      },
    },
  },
  methods: {
    ...mapActions(['setSnackBarStateAction']),
  },
};
</script>

<style lang="scss">
@import url('~vue2-dropzone/dist/vue2Dropzone.min.css');
html,
body {
  margin: 0;
  height: 100%;
  overflow: hidden;
}
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.25s ease-out;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
